import Button from 'components/Form/Button';
import ContainerAuthenticated from 'containers/Authenticated';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { LogoSpinner } from 'screens/Dashboard/Home/styled';
import {
  EproposalContainer,
  EproposalFormsWrapper,
} from 'screens/Eproposal/styled';
import { ReadOne } from 'services/financing-eproposta';
import { Title } from 'ui/styled';
import { capitalize } from 'utils';
import {
  esadoCivilOptions,
  genderOptions,
  nacionalidadeOptions,
  optionsOrgaoEmissorRg,
  optionsStates,
  situacOptions,
} from 'utils/options';
import { formatPhone } from 'utils/parsers';
import FormCore from '../../components/Form/Core';
import {
  FormSpacing,
  HeaderButtonContainer,
} from '../FinancingProposalNew/styled';

export default function EProposalMirror() {
  const { id } = useParams();
  const refForm = useRef();
  const refFormInstallationAddress = useRef();
  const refFormCliente = useRef();
  const refFormProfessional = useRef();
  const [loading, setLoading] = useState(true);

  const spinnerImagePath = '/images/circulo_tes2.svg';

  const history = useHistory();

  const handleBuscaPreData = async (id) => {
    setLoading(true);
    try {
      const res = await ReadOne(id);
      return res;
    } catch (err) {
      console.log('ServerParseError', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInitialForm = useCallback(async () => {
    const data = await handleBuscaPreData(id);

    // === 1. FORMULÁRIO DO CLIENTE ===
    const cpfCnpj = data?.cliente?.cpf || data?.cliente?.cnpj || '';

    refFormCliente?.current?.setItem(
      data?.cliente?.telefone_fixo,
      'telefone_fixo'
    );
    refFormCliente?.current?.setItem(data?.cliente?.nome_mae, 'nome_mae');
    refFormCliente?.current?.setItem(
      data?.cliente?.estado_civil,
      'estado_civil'
    );
    refFormCliente?.current?.setItem(data?.cliente?.genero, 'genero');
    refFormCliente?.current?.setItem(
      data?.cliente?.nacionalidade,
      'nacionalidade'
    );
    refFormCliente?.current?.setItem(data?.cliente?.rg, 'rg');

    refFormCliente?.current?.setItem(
      data?.cliente?.tipo_cliente
        ? capitalize(data?.cliente?.tipo_cliente)
        : '',
      'tcc2'
    );

    refFormCliente?.current?.setItem(
      data?.cliente?.nome_completo?.trim() || '',
      'nome_completo'
    );
    refFormCliente?.current?.setItem(cpfCnpj, 'cpf');
    refFormCliente?.current?.setItem(data?.cliente?.email || '', 'email');
    refFormCliente?.current?.setItem(
      formatPhone('', data?.cliente?.telefone_celular),
      'telefone_celular'
    );
    refFormCliente?.current?.setItem(
      data?.cliente?.data_nascimento || '',
      'data_nascimento'
    );

    refFormCliente?.current.setItem(
      data?.informacoes_cliente?.rg_emissor || '',
      'rg_emissor'
    );
    refFormCliente?.current.setItem(
      data?.informacoes_cliente?.rg_emissor_uf || '',
      'rg_emissor_uf'
    );
    refFormCliente?.current.setItem(
      data?.informacoes_cliente?.rg_data_emissao || '',
      'rg_data_emissao'
    );

    // Endereço residencial do cliente
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.cep || '',
      'cep_cliente'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.rua || '',
      'logradouro_cliente'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.numero || '',
      'numero_cliente'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.complemento || '',
      'complemento'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.bairro || '',
      'bairro'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.cidade || '',
      'cidade'
    );
    refFormCliente?.current?.setItem(
      data?.endereco_residencial?.uf || '',
      'estado'
    );

    refFormCliente?.current?.setItem(data?.id, 'id_pre_proposta');

    // === 2. ENDEREÇO DE INSTALAÇÃO (mesmo do cliente na pré-proposta) ===
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.cep || '',
      'cep'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.rua || '',
      'rua'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.numero || '',
      'numero'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.complemento || '',
      'complemento'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.bairro || '',
      'bairro'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.cidade || '',
      'cidade'
    );
    refFormInstallationAddress?.current?.setItem(
      data?.endereco_instalacao?.uf || '',
      'estado'
    );
    // === 3. INFORMAÇÕES PROFISSIONAIS ===
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.profissao,
      'profissao'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.ocupacao,
      'ocupacao'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.nome_empresa,
      'nome_empresa'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.telefone_empresa,
      'telefone_empresa'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.tempo_empresa,
      'tempo_empresa'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.patrimonio_estimado,
      'patrimonio_estimado'
    );
    refFormProfessional?.current?.setItem(
      data?.informacoes_profissionais?.renda_mensal,
      'renda_mensal'
    );
    refFormProfessional?.current?.setItem(
      data?.situacao_imovel,
      'situacao_imovel'
    );

    // === 4. DADOS DO PROJETO (principais) ===
    if (refForm?.current) {
      refForm.current.setItem(
        data?.informacoes_projeto?.custo_produto,
        'custo_produto'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.valor_financiamento,
        'custo_total_projeto'
      );
      refForm.current.setItem(
        data?.pre_proposal?.cnpj_integrador || '',
        'cnpj_integrador'
      );
      refForm.current.setItem(
        formatPhone('', data?.pre_proposal?.telefone_vendedor),
        'telefone_vendedor'
      );
      refForm.current.setItem(
        data?.pre_proposal?.nome_vendedor || '',
        'nome_vendedor'
      );

      refForm.current.setItem(
        formatPhone('', data?.telefone_integrador),
        'telefone_integrador'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.custo_servico,
        'custo_servico'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.valor_outros_produtos,
        'valor_outros_produtos'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.quantidade_placas,
        'quantidade_placas'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.quantidade_inversores,
        'quantidade_inversores'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.marca_placas,
        'marca_placas'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.potencia_W_placas,
        'potencia_modulo'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.potencia_kWp,
        'potencia_kWp'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.marca_inversores,
        'marca_inversores'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.potencia_kW_inversor,
        'potencia_kW_inversor'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.geracao_energia_estimada,
        'geracao_energia_estimada'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.concessionaria,
        'concessionaria'
      );
      refForm.current.setItem(
        data?.informacoes_projeto?.unidade_consumidora,
        'unidade_consumidora'
      );
      refForm.current.setItem(
        data?.cod_proposta_externa,
        'cod_proposta_externa'
      );
      refForm.current.setItem(
        data?.cod_proposta_externa,
        'cod_proposta_externa'
      );
    }
  }, [id]);

  useEffect(() => handleInitialForm(), [handleInitialForm]);

  const formProjectItems = [
    {
      ref: 'cnpj_integrador',
      placeholder: 'CNPJ Integrador',
      tress: true,
      disabled: true,
      required: true,
      transparent: false,
    },
    {
      ref: 'telefone_integrador',
      placeholder: 'Telefone Integrador',
      disabled: true,
      tress: true,
      required: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'nome_vendedor',
      placeholder: 'Nome Completo do Vendedor',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'telefone_vendedor',
      placeholder: 'Telefone do Vendedor',
      disabled: true,
      tress: true,
      required: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'custo_produto',
      type: 'money',
      placeholder: 'Valor dos Produtos',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'custo_servico',
      type: 'money',
      placeholder: 'Valor do Serviço',
      tress: true,
      disabled: true,
      required: false,
    },
    {
      ref: 'valor_outros_produtos',
      type: 'money',
      placeholder: 'Valor Outros',
      required: false,
      default: 0,
      tress: true,
      disabled: true,
    },
    {
      ref: 'custo_total_projeto',
      type: 'money',
      placeholder: 'Valor Total',
      tress: true,
      required: false,
      disabled: true,
    },
    {
      ref: 'quantidade_placas',
      type: 'number',
      placeholder: 'Quantidade de Módulos',
      tress: true,
      disabled: true,
      required: true,
      min: '0',
      step: '1',
    },
    {
      ref: 'marca_placas',
      placeholder: 'Marca dos Módulos',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'potencia_modulo',
      type: 'number',
      placeholder: 'Potência W dos Módulos',
      tress: true,
      disabled: true,
      required: true,
      min: '0',
      step: '0.01',
    },
    {
      ref: 'potencia_kWp',
      type: 'number',
      placeholder: 'Potência kWp Total',
      tress: true,
      required: false,
      disabled: true,
    },
    {
      ref: 'quantidade_inversores',
      type: 'number',
      placeholder: 'Quantidade de Inversores',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'marca_inversores',
      placeholder: 'Marca dos Inversores',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'potencia_kW_inversor',
      type: 'number',
      placeholder: 'Potência kW Total',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'geracao_energia_estimada',
      type: 'number',
      placeholder: 'Geração de Energia kW/h no Primeiro Ano',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'concessionaria',
      placeholder: 'Concessionária de Energia',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'unidade_consumidora',
      placeholder: 'Unidade Consumidora',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'cod_proposta_externa',
      placeholder: 'Número da Proposta Comercial',
      required: false,
      tress: true,
      disabled: true,
    },
  ];

  const formInstallationAddress = [
    {
      ref: 'cep',
      placeholder: 'CEP',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'rua',
      placeholder: 'Logradouro',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'numero',
      placeholder: 'Número',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'complemento',
      placeholder: 'Complemento',
      tress: true,
      disabled: true,
      required: false,
    },
    {
      ref: 'bairro',
      placeholder: 'Bairro',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'cidade',
      placeholder: 'Cidade',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'estado',
      placeholder: 'Estado',
      tress: true,
      disabled: true,
      required: true,
    },
  ];

  const formCliente = [
    {
      ref: 'tcc2',
      placeholder: 'Tipo de Pessoa',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'nome_completo',
      placeholder: 'Nome Completo',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'cpf',
      placeholder: 'CPF/CNPJ',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'data_nascimento',
      placeholder: 'Data de Nascimento',
      type: 'date',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'email',
      placeholder: 'E-mail',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'telefone_celular',
      placeholder: 'Telefone Celular',
      required: true,
      tress: true,
      disabled: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'telefone_fixo',
      placeholder: 'Telefone Fixo',
      required: false,
      tress: true,
      disabled: true,
      Tooltip: 'Preencha com números válidos — indispensável para comunicação.',
    },
    {
      ref: 'estado_civil',
      placeholder: 'Estado Civil',
      tress: true,
      disabled: true,
      required: true,
      options: esadoCivilOptions,
    },
    {
      ref: 'nome_mae',
      placeholder: 'Nome Completo da Mãe',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'rg',
      placeholder: 'RG',
      type: 'number',
      tress: true,
      disabled: true,
    },
    {
      ref: 'rg_data_emissao',
      placeholder: 'Data de Emissão',
      type: 'date',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'rg_emissor',
      placeholder: 'Orgão Emissor',
      required: true,
      tress: true,
      disabled: true,
      options: optionsOrgaoEmissorRg,
    },
    {
      ref: 'rg_emissor_uf',
      placeholder: 'UF de Emissão',
      required: true,
      tress: true,
      disabled: true,
      options: optionsStates,
    },

    {
      ref: 'rg',
      placeholder: 'RG',
      type: 'number',
      required: false,
      tress: true,
      disabled: true,
    },

    {
      ref: 'genero',
      placeholder: 'Sexo',
      options: genderOptions,
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'nacionalidade',
      placeholder: 'Nacionalidade',
      tress: true,
      disabled: true,
      required: true,
      options: nacionalidadeOptions,
    },
    {
      ref: 'cep_cliente',
      placeholder: 'CEP',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'logradouro_cliente',
      placeholder: 'Logradouro',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'numero_cliente',
      placeholder: 'Número',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'complemento',
      placeholder: 'Complemento',
      tress: true,
      disabled: true,
      required: false,
    },
    {
      ref: 'bairro',
      placeholder: 'Bairro',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'cidade',
      placeholder: 'Cidade',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'estado',
      placeholder: 'Estado',
      tress: true,
      disabled: true,
      required: true,
    },
    {
      ref: 'id_pre_proposta',
      placeholder: 'ID Pré-Proposta',
      required: false,
      disabled: true,
    },
  ];

  const formProfessional = [
    {
      ref: 'profissao',
      placeholder: 'Profissão',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'ocupacao',
      placeholder: 'Ocupação',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'nome_empresa',
      placeholder: 'Nome da Empresa',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'telefone_empresa',
      placeholder: 'Telefone da empresa',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'tempo_empresa',
      placeholder: 'Tempo de Empresa (Meses)',
      type: 'number',
      required: true,
      min: 0,
      tress: true,
      disabled: true,
    },
    {
      ref: 'renda_mensal',
      placeholder: 'Renda Mensal',
      type: 'money',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'patrimonio_estimado',
      placeholder: 'Patrimônio Estimado',
      type: 'money',
      required: true,
      tress: true,
      disabled: true,
    },
    {
      ref: 'situacao_imovel',
      placeholder: 'Situação do Imóvel',
      required: true,
      options: situacOptions,
      tress: true,
      disabled: true,
    },
  ];

  return (
    <ContainerAuthenticated>
      {loading ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <LogoSpinner src={spinnerImagePath} alt="Logo rotativo" />
        </div>
      ) : (
        <EproposalFormsWrapper>
          <Title>Espelho E-Proposta</Title>
          <EproposalContainer>
            <HeaderButtonContainer>
              <Title small nomargin>
                Informações do Cliente
              </Title>
              <Button
                color="blue"
                width={'fit-content'}
                small
                nospace
                onClick={() => history.goBack()}
              >
                Voltar
              </Button>
            </HeaderButtonContainer>
            <FormCore ref={refFormCliente} formItems={formCliente} />
            <FormSpacing />
            <Title small nomargin>
              Endereço de Instalação
            </Title>
            <FormCore
              ref={refFormInstallationAddress}
              formItems={formInstallationAddress}
            />
            <FormSpacing />
            <Title small nomargin>
              Informações do Projeto
            </Title>
            <FormCore ref={refForm} formItems={formProjectItems} />
            <FormSpacing />
            <Title small nomargin>
              Informações Profissionais
            </Title>

            <FormCore ref={refFormProfessional} formItems={formProfessional} />

            <FormSpacing />
          </EproposalContainer>
        </EproposalFormsWrapper>
      )}
    </ContainerAuthenticated>
  );
}
